module.exports = __webpack_public_path__ + "img/744.0f85718f.jpg";